"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validatePostalCode;
var parseValueByCountryCode = function parseValueByCountryCode(countryCode, postalCode) {
  if (countryCode === 'US') {
    return postalCode === null || postalCode === void 0 ? void 0 : postalCode.split('-')[0];
  }
  return postalCode;
};
function validatePostalCode(postalCode, countryCode, validationRegex) {
  var value = parseValueByCountryCode(countryCode, postalCode);
  return new RegExp(validationRegex).test(value) ? undefined : 'react-ui.validation.invalid';
}